import { render, staticRenderFns } from "./gjjl.vue?vue&type=template&id=1a14c95c&scoped=true&"
import script from "./gjjl.vue?vue&type=script&lang=js&"
export * from "./gjjl.vue?vue&type=script&lang=js&"
import style0 from "./gjjl.vue?vue&type=style&index=0&id=1a14c95c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a14c95c",
  null
  
)

export default component.exports